import { render, staticRenderFns } from "./transaccion.vue?vue&type=template&id=734708db"
import script from "./transaccion.js?vue&type=script&lang=js&external"
export * from "./transaccion.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports